<template>
  <form class="dashboard-block">
    <h2>Privacy &amp; Communication</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <div class="form-horizontal">
          <div class="row">
            <div class="col-xs-12">
              <div class="checkbox checkbox-primary">
                <div class="input-group-checkbox">
                  <input
                    type="checkbox"
                    id="ff-marketing-opt-in"
                    name="marketingOptIn"
                    v-model="optedIn"
                  >
                  <label for="ff-marketing-opt-in">
                    I wish to receive news and marketing material from {{ clientName }}
                  </label>
                </div>
              </div>
              <ladda-button button class="btn btn-primary pull-right margin-y-1" :click="handleSavePrivacyDataCallback" :disabled="userIsAdmin && !canEditAdmin">
                Save
              </ladda-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-t-xl">
      <p>If you would like to request a copy of your data, or request the removal of your data on our platform, please write to us at <a :href="`mailto:${this.$privacyEmail}`">{{ this.$privacyEmail }}</a></p>
    </div>
  </form>
</template>

<script>
import { helpers } from 'mixins/users'
import { mapState, mapActions } from 'vuex'
import { notify } from 'utils'

export default {
  mixins: [helpers],

  computed: {
    ...mapState('user', ['user']),
    optedIn: {
      get () {
        return this.user.marketing_opted_in
      },
      set (value) {
        this.setUserProperty({ property: 'marketing_opted_in', value })
      }
    }
  },

  methods: {
    ...mapActions('user', ['setUserProperty', 'saveMarketingOptIn']),

    handleSavePrivacyDataCallback () {
      return this.saveMarketingOptIn({ id: this.user.id, payload: { opt_in: this.user.marketing_opted_in } }).then(() => {
        notify.success('Saved your notification preference')
      }).catch(error => {
        notify.error(`Unable to save notification preference. Please contact ${this.clientName} at ${this.$privacyEmail}`)
        throw error
      })
    }
  }
}
</script>
